import { Route, Routes } from 'react-router-dom'

import Auctions from './screens/Auctions'
import Campaigns from './screens/Campaigns'
import Deadlines from './screens/Deadlines'
import Inspections from './screens/Inspections'
import Orders from './screens/Orders'
import PortalSyncs from './screens/PortalSyncs'
import Quotes from './screens/Quotes'
import Signboards from './screens/Signboards'

const OverviewsRoutes = () => (
  <Routes>
    <Route path="/auctions" element={<Auctions />} />
    <Route path="/campaigns" element={<Campaigns />} />
    <Route path="/deadlines/*" element={<Deadlines />} />
    <Route path="/inspections" element={<Inspections />} />
    <Route path="/orders" element={<Orders />} />
    <Route path="/portalSyncs" element={<PortalSyncs />} />
    <Route path="/quotes" element={<Quotes />} />
    <Route path="/signboards" element={<Signboards />} />
  </Routes>
)

export default OverviewsRoutes
